// Module
var code = "<fd-form-buttons ng-if=vm.isSubmitSectionVisible> <right> <fd-form-button on-click=vm.goToTicket($event) label=app.submitRequest.goToTicket> </fd-form-button> </right> </fd-form-buttons> ";
// Exports
var _module_exports = code;;
var path = 'app/components/tickets/create/receiving/submitRequest/partials/directBank/submitRequest.formButton.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;